import TextField from "@mui/material/TextField";

interface Props {
  value: string;
  setValue(v: string): void;
  title: string;
  placeholder: string;
}

export default function SearchField({ value, setValue, title, placeholder }: Props) {
  return (
    <TextField
      sx={{ width: "400px" }}
      type="text"
      value={value}
      size="small"
      onChange={v => setValue(v.currentTarget.value)}
      label={title}
      placeholder={placeholder}
    ></TextField>
  );
}
